import type { ReviewState } from '../../api/libraryAdminApi';

const REPLACED_BY_GENERATION = [
  'sensitivity',
  'story',
  'performance',
  'artwork_rights',
  'artwork',
];

export type DraftPipelinePresentation = {
  disabled: boolean;
  kind: 'reviewed' | 'unconfigured' | 'busy' | 'ready';
  label: string;
  message: string | null;
};

export const getDraftPipelinePresentation = (
  reviews: Record<string, ReviewState>,
  generationEnabled: boolean,
  generationState: string,
): DraftPipelinePresentation => {
  const approvedGeneratedArtifacts = REPLACED_BY_GENERATION.filter(
    (stage) => reviews[stage]?.current,
  );
  if (approvedGeneratedArtifacts.length) {
    return {
      disabled: true,
      kind: 'reviewed',
      label: 'Reviewed draft — generation locked',
      message: 'This title already has approved draft artifacts. Continue to listening review, or start a new editorial version before regenerating.',
    };
  }
  if (!generationEnabled) {
    return {
      disabled: true,
      kind: 'unconfigured',
      label: 'Run full draft pipeline',
      message: 'Generation is unavailable until the server flag and provider key are configured.',
    };
  }
  if (['queued', 'running'].includes(generationState)) {
    return {
      disabled: true,
      kind: 'busy',
      label: generationState === 'queued' ? 'Generation queued…' : 'Generating draft…',
      message: 'The draft pipeline is running. It cannot approve or publish anything.',
    };
  }
  return {
    disabled: false,
    kind: 'ready',
    label: 'Run full draft pipeline',
    message: 'Generates new sensitivity, story, performance, and artwork drafts for human review.',
  };
};
